import useDefaultInputStyles from "../../hooks/useDefaultInputStyles";

function Button({ ...props }) {
  props = useDefaultInputStyles(props);

  // const onClick = (evt) => {

  //     if (props.onClick) {
  //         evt.preventDefault()
  //         props.onClick();
  //     }
  // }



  return (
    <button type="button"  {...props} ></button>
  )
}

export default Button;
